import { I18nConfig } from 'haba-core';
import { deTranslations } from 'src/assets/i18n-assets/de/translations';
import { enTranslations } from 'src/assets/i18n-assets/en/translations';
import { translationChunksConfig } from './translation-chunks-config';

export const habaI18nConfig: I18nConfig = {
  i18n: {
    resources: { en: enTranslations, de: deTranslations },
    chunks: {
      common: ['httpHandlers'],
      habaAltText: ['altText'],
      cookiePage: ['title', 'text', 'preferences', 'statistics', 'marketing', 'unclassified'],
      habaCart: [
        'habaVoucher',
        'habaMiniCart',
        'habaPopupCart',
        'habaCart',
        'habaCartDetails',
        'directOrderForm',
      ],
      habaCheckout: [
        'habaOrderSummary',
        'habaConfirmation',
        'habaPayment',
        'habaPlaceOrder',
        'habaGuestLogin',
        'habaCheckoutProgress',
        'habaCheckoutReview',
        'habaCheckoutFooter',
      ],
      habaProduct: [
        'habaProductCard',
        'habaProductDetails',
        'habaProductConfigurator',
        'habaProductVariants',
        'habaProductConsultant',
      ],
      habaCommon: [
        'habaSearch',
        'habaNavigation',
        'habaHttpHandlers',
        'habaAuthentication',
        'habaFooter',
        'habaEmptyCategory',
        'countdownBanner',
        'breadcrumbs',
        'blogPage',
        'postalCode',
        'pageHero',
      ],
      habaAddress: ['habaAddressForm', 'habaAddressMelissa', 'correctionDialog'],
      habaAddressBook: ['habaAddressBook'],
      habaContactForm: ['habaContactForm'],
      habaUser: [
        'habaCommonUserInformation',
        'habaLoginForm',
        'habaRegisterForm',
        'habaNavLogin',
        'habaForgottenPassword',
        'habaProRegisterForm',
        'habaAccountOverview',
        'habaCustomerData',
        'habaOrderHistory',
        'habaNewsletterProcess',
        'habaBillingAddress',
        'habaRegistrationBenefits',
        'habaChat',
      ],
      habaCountries: ['countries', 'languages'],
      habaCountryPopup: ['countryPopup'],
      habaMyAccountNavigation: ['myAccountNavigation'],
      habaMyAccountOrderHistory: ['myOrderHistory', 'orderHistoryDetails'],
      habaWishlist: [
        'wishlistOverview',
        'wishlistCreate',
        'wishlistEdit',
        'wishlistList',
        'wishlistMove',
        'wishlistAdd',
      ],
      overwriteDefaults: ['organization'],
      userProfile: ['customerNumber', 'extraInfo'],
      ...translationChunksConfig,
    },
    fallbackLang: 'en',
  },
};
